import * as React from "react";
import { Loader, Table } from "semantic-ui-react";

import { DecisionPendingClarificationOptions, HealthSurveillanceOutcomeModel, MedicalOutcome } from "@teamprevent/common/healthSurveillance/models";
import { getHSOutcomeIcon } from "@teamprevent/common/healthSurveillance/certificate/OutcomeDetails";

import { getMedicalTypeName } from "@teamprevent/common/customMedicalTypes/model";
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { useCustomMedicalTypes } from "../../../customMedicalTypes/hooks/useCustomMedicalTypes";

interface OwnProps {
    medicalOutcome: HealthSurveillanceOutcomeModel;
}

const ReviewHealthSurveillanceOutcome: React.FunctionComponent<OwnProps> = (props: OwnProps) => {

    const outcomeName = MedicalOutcome[props.medicalOutcome.outcome];
    const { customMedicalTypes, isLoaded: areCustomMedicalTypesLoaded } = useCustomMedicalTypes();
    const enableHealthSurveillanceCrs11_3 = getFeatureToggles()[FeatureToggleNames.EnableHealthSurveillanceCrs11_3];

    if (areCustomMedicalTypesLoaded === false)
    {
        return <Loader active />;
    }

    return (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell width="6">{getMedicalTypeName(customMedicalTypes, props.medicalOutcome.medicalTypeId)}</Table.HeaderCell>
                    <Table.HeaderCell width="6" />
                    <Table.HeaderCell width="4" />
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <Table.Row>
                    <Table.Cell><strong>Outcome</strong></Table.Cell>
                    <Table.Cell>{outcomeName}</Table.Cell>
                    <Table.Cell>{getHSOutcomeIcon(outcomeName)}</Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell><strong>Clinical Notes</strong></Table.Cell>
                    <Table.Cell>{props.medicalOutcome.clinicalNotes}</Table.Cell>
                    <Table.Cell />
                </Table.Row>
                <Table.Row>
                    <Table.Cell><strong>Customer Notes</strong></Table.Cell>
                    <Table.Cell>{props.medicalOutcome.customerNotes}</Table.Cell>
                    <Table.Cell />
                </Table.Row>
                {enableHealthSurveillanceCrs11_3 && props.medicalOutcome.outcome === "decisionPending" && <Table.Row>
                    <Table.Cell><strong>Decision Pending Clarification</strong></Table.Cell>
                    <Table.Cell>{DecisionPendingClarificationOptions
                        .find(o => o.value === props.medicalOutcome.decisionPendingClarification)?.text}</Table.Cell>
                    <Table.Cell />
                </Table.Row>}
                {!!props.medicalOutcome.recallYears &&
                    <Table.Row>
                        <Table.Cell><strong>Recall Years</strong></Table.Cell>
                        <Table.Cell>{props.medicalOutcome.recallYears}</Table.Cell>
                        <Table.Cell />
                    </Table.Row>
                }
                {!!props.medicalOutcome.recallWeeks &&
                    <Table.Row>
                        <Table.Cell><strong>Recall Weeks</strong></Table.Cell>
                        <Table.Cell>{props.medicalOutcome.recallWeeks}</Table.Cell>
                        <Table.Cell />
                    </Table.Row>
                }
            </Table.Body>
        </Table>
    );
};

export { ReviewHealthSurveillanceOutcome };
